// import React, { useEffect, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';
// import NeatixModal from '@components/Modal/NeatixModal';
// import AddCreateAccountInventory from './AddCreateAccountInventory';
// import NtxTable from '@components/DataTable/NtxTable';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getTransactionsListToPost } from '@store/INV/Transactions/InvIssue/invSlice';
// import { usePermissions } from '@Helper/Permisstions/usePermissions';

// const ListTransactions = () => {
//   const { HasPermission } = usePermissions();
//   const [showModal, setShowModal] = useState(false);
//   const dispatch = useAppDispatch();
//   const { t } = useTranslation();

//   const { TransactionsListToPost: data, error, loading } = useAppSelector(s => s.Inv);
//   useEffect(() => {
//     dispatch(getTransactionsListToPost());
//   }, []);

//   //____________________________
//   const [selectedTransactions, setSelectedTransactions] = useState<string[] | any>([]);
//   const handleCheckboxChange = (row: any) => {
//     setSelectedTransactions((prevSelectedRows: any) => {
//       const isSelected = prevSelectedRows?.some((item: any) => item.id === row.id);

//       if (isSelected) {
//         return prevSelectedRows?.filter((item: any) => item.id !== row.id);
//       } else {
//         return [...prevSelectedRows, row];
//       }
//     });
//   };

//   const handleOpenAddCreateAccount = () => {
//     if (selectedTransactions?.length > 0) {
//       setShowModal(true);
//     }
//   };

//   const columns = [
//     { title: '', key: 'checkBox', className: 'text-center' },
//     { title: t('TransType'), key: 'type' },
//     { title: t('تاريخ الحركة'), key: 'date' },
//     { title: t('Code'), key: 'num' },
//     { title: t('رقم المرجع'), key: 'ref' },
//     { title: t('Status'), key: 'status' }
//   ];

//   const tableData = data?.map((item: any) => {
//     // let rowClass;

//     const postedFlagBadge = item.postedFlag ? (
//       <span className='badge bg-success'>
//         <i className='fas fa-check me-1'></i> {/* أيقونة للترحيل */}
//         {t('Posted')}
//       </span>
//     ) : (
//       <span className='badge bg-danger'>
//         <i className='fas fa-times me-1'></i> {/* أيقونة لعدم الترحيل */}
//         {t('NotPosted')}
//       </span>
//     );

//     const getTransactionBadge = (transactionType: string) => {
//       switch (transactionType) {
//         case 'مردود مشتريات':
//           return (
//             <span className='badge bg-warning'>
//               <i className='fas fa-undo me-1'></i> {t('PurchaseReturn')}
//             </span>
//           );
//         case 'امر صيانة':
//           return (
//             <span className='badge bg-info'>
//               <i className='fas fa-tools me-1'></i> {t('MaintenanceOrder')}
//             </span>
//           );
//         case 'Move Order Issue':
//           return (
//             <span className='badge bg-danger '>
//               <i className='fas fa-exchange-alt me-1'></i> {t('صرف أمر تحويل')}
//             </span>
//           );
//         case 'Sales Order Issue':
//           return (
//             <span className='badge bg-primary'>
//               <i className='fas fa-shopping-cart me-1'></i> {t('أمـر بيـع')}
//             </span>
//           );
//         case 'Miscellaneous Issue':
//           return (
//             <span className='badge bg-danger'>
//               <i className='fas fa-arrow-up me-1'></i> {t('صـرف')}
//             </span>
//           );
//         case 'صرف مواد خام':
//           return (
//             <span className='badge bg-dark'>
//               <i className='fas fa-box-open me-1'></i> {t('RawMaterialIssue')}
//             </span>
//           );
//         case 'استلام منتج نهائي':
//           return (
//             <span className='badge bg-success'>
//               <i className='fas fa-box me-1'></i> {t('FinalProductReceipt')}
//             </span>
//           );
//         case 'استلام امر تحويل':
//           return (
//             <span className='badge bg-secondary'>
//               <i className='fas fa-exchange-alt me-1'></i> {t('TransferReceipt')}
//             </span>
//           );
//         case 'Miscellaneous Receipt':
//           return (
//             <span className='badge bg-success'>
//               <i className='fas fa-plus me-1'></i> {t('إضـافة')}
//             </span>
//           );
//         case 'Purchases Order':
//           return (
//             <span className='badge bg-primary'>
//               <i className='fas fa-shopping-bag me-1'></i> {t('امر شراء')}
//             </span>
//           );
//         case 'مردود مبيعات':
//           return (
//             <span className='badge bg-warning'>
//               <i className='fas fa-reply me-1'></i> {t('SalesReturn')}
//             </span>
//           );
//         default:
//           return (
//             <span className='badge bg-secondary'>
//               <i className='fas fa-question-circle me-1'></i> {t('Unknown')}
//             </span>
//           );
//       }
//     };

//     return {
//       checkBox: (
//         <div className='form-check'>
//           <input
//             type='checkbox'
//             className='form-check-input'
//             id={`checkbox-${item.id}`}
//             checked={selectedTransactions?.some((row: any) => row.id === item.id)}
//             onChange={() => handleCheckboxChange(item)}
//           />
//         </div>
//       ),
//       num: item.code,
//       date: item.transactionDate?.split('T')[0],
//       type2: item.transactionTypeName,
//       type: getTransactionBadge(item.transactionTypeName), // إضافة الشارة

//       ref: item.referenceCode,
//       status: postedFlagBadge,
//       // type: item.transactionTypeName,

//       postedFlag: '~~' // استخدام الشارة هنا
//     };
//   });

//   //____________________________
//   const BcrumbList = [
//     {
//       name: 'Home',
//      link: ':moduleHome'
//     },

//     {
//       name: 'CreateAccountInventory',
//       link: null
//     }
//   ];

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb BreadcrumbList={BcrumbList} PageName='CreateAccountInventory' />

//         <div className='ms-auto'>
//           {HasPermission('INVAddCreateAccountInventory') && (
//             <button type='button' className='btn me-1 btn-theme ' onClick={handleOpenAddCreateAccount}>
//               <i className='fa fa-share-square fa-fw me-1'></i>
//               {t('Post')}
//             </button>
//           )}
//         </div>
//       </div>
//       <Card>
//         <Loading loading={loading} error={error}>
//           <CardBody>
//             <div className=' p-2'>
//               <NtxTable
//                 data={tableData || []}
//                 columns={columns}
//                 dataPerPage={10}
//                 theadClass=''
//                 tableClass='table text-nowrap table-hover '
//                 enableSearch={true}
//                 showRecordsSelector
//               />
//             </div>
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal show={showModal} setShow={setShowModal} bodyClassName='p-0' size='xl' showHeader={false} backdrop>
//         <Card>
//           <CardBody>
//             {selectedTransactions?.length > 0 && (
//               <AddCreateAccountInventory
//                 selectedTransactions={selectedTransactions}
//                 onclose={() => {
//                   setShowModal(false);
//                   setSelectedTransactions([]); // مسح التحديد بعد الترحيل
//                   dispatch(getTransactionsListToPost()); // إعادة تحميل البيانات لتحديث الحالة
//                 }}
//               />
//             )}
//           </CardBody>
//         </Card>
//       </NeatixModal>
//     </div>
//   );
// };

// export default ListTransactions;


import { useEffect, useMemo, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import NeatixModal from '@components/Modal/NeatixModal';
import Select from 'react-select';

import { usePermissions } from '@Helper/Permisstions/usePermissions';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';

import AddCreateAccountInventory from './AddCreateAccountInventory';

import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermissionCache';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';

const TABLE_KEY = 'Inv_Unposted_Index';

const ListTransactionsToPost = () => {
  const { t, i18n } = useTranslation();
  const { HasPermission } = usePermissions();
  const dispatch = useAppDispatch();

  const { OperatingUnitOptions, loading: loadingOperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInventoryOptions } = useGetInventoryWithPermission();

  // ===========================
  // DynamicTable state
  // ===========================
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ===========================
  // Local filters
  // ===========================
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [inventoryFilter, setInventoryFilter] = useState<any>(null);
  const [transTypeFilter, setTransTypeFilter] = useState<any>(null);

  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [showFilters, setShowFilters] = useState(false);

  // ===========================
  // Selection + Modal
  // ===========================
  const [selectedTransactions, setSelectedTransactions] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);

  // ===========================
  // Init table
  // ===========================
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Inv/GeUnposted-Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ===========================
  // Helpers
  // ===========================
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  const safeDate = (dt: string) => (dt ? dt.split('T')[0] : '—');

  const getPostedFlagBadge = (flag: boolean) =>
    flag ? (
      <span className='badge bg-success'>
        <i className='fas fa-check me-1'></i>
        {t('Posted')}
      </span>
    ) : (
      <span className='badge bg-danger'>
        <i className='fas fa-times me-1'></i>
        {t('NotPosted')}
      </span>
    );

  const getTransactionBadge = (transactionType: string) => {
    const type = (transactionType || '').trim();

    switch (type) {
      case 'مردود مشتريات':
      case 'Supplier Return':
        return (
          <span className='badge bg-warning'>
            <i className='fas fa-undo me-1'></i> {t('PurchaseReturn')}
          </span>
        );

      case 'امر صيانة':
      case 'Work Order':
        return (
          <span className='badge bg-info'>
            <i className='fas fa-tools me-1'></i> {t('MaintenanceOrder')}
          </span>
        );

      case 'Move Order Issue':
      case 'صرف أمر تحويل':
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-exchange-alt me-1'></i> {t('TransferOrderIssue') || 'صرف أمر تحويل'}
          </span>
        );

      case 'Move Order Receipt':
      case 'استلام امر تحويل':
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-exchange-alt me-1'></i> {t('TransferReceipt')}
          </span>
        );

      case 'Sales Order Issue':
      case 'أمـر بيـع':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-shopping-cart me-1'></i> {t('SalesOrder') || 'أمر بيع'}
          </span>
        );

      case 'Miscellaneous Issue':
      case 'صـرف':
        return (
          <span className='badge bg-danger'>
            <i className='fas fa-arrow-up me-1'></i> {t('Issue') || 'صرف'}
          </span>
        );

      case 'Miscellaneous Receipt':
      case 'إضـافة':
        return (
          <span className='badge bg-success'>
            <i className='fas fa-plus me-1'></i> {t('Addition') || 'إضافة'}
          </span>
        );

      case 'Purchases Order':
      case 'امر شراء':
        return (
          <span className='badge bg-primary'>
            <i className='fas fa-shopping-bag me-1'></i> {t('PurchaseOrder') || 'أمر شراء'}
          </span>
        );

      case 'مردود مبيعات':
      case 'Sales Return':
        return (
          <span className='badge bg-warning'>
            <i className='fas fa-reply me-1'></i> {t('SalesReturn')}
          </span>
        );

      default:
        return (
          <span className='badge bg-secondary'>
            <i className='fas fa-question-circle me-1'></i> {type || t('Unknown')}
          </span>
        );
    }
  };

  // ✅ خيارات نوع الحركة من نفس بيانات الصفحة (Paged)
  const transTypeOptions = useMemo(() => {
    const map = new Map<string, { value: string; label: string }>();

    (data || []).forEach((x: any) => {
      const id = x?.transactionTypeId;
      if (!id) return;

      const name =
        i18n.language === 'en'
          ? x?.transactionTypeName
          : x?.transactionTypeName2 || x?.transactionTypeName;

      if (!map.has(id)) map.set(id, { value: id, label: name || '—' });
    });

    return Array.from(map.values()).sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  }, [data, i18n.language]);

  // ===========================
  // Selection
  // ===========================
  const isRowSelected = (row: any) => selectedTransactions.some(s => s.id === row.id);

  const handleCheckboxChange = (row: any) => {
    setSelectedTransactions(prev => {
      const exists = prev.some(s => s.id === row.id);
      return exists ? prev.filter(s => s.id !== row.id) : [...prev, row];
    });
  };

  const handleSelectAllPage = () => {
    if (!data?.length) return;

    const allSelected = data.every((row: any) => selectedTransactions.some(s => s.id === row.id));

    if (allSelected) {
      // إزالة بيانات الصفحة فقط
      setSelectedTransactions(prev => prev.filter(s => !data.some((row: any) => row.id === s.id)));
    } else {
      // إضافة بيانات الصفحة فقط (بدون تكرار)
      setSelectedTransactions(prev => {
        const next = [...prev];
        data.forEach((row: any) => {
          if (!next.some(s => s.id === row.id)) next.push(row);
        });
        return next;
      });
    }
  };

  const handleOpenPostModal = () => {
    if (selectedTransactions.length > 0) setShowModal(true);
  };

  // ===========================
  // Apply/Clear filters
  // ===========================
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (branchFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'branchId',
        operator: 0,
        value: branchFilter.value
      });
    }

    if (inventoryFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'inventoryId',
        operator: 0,
        value: inventoryFilter.value
      });
    }

    if (transTypeFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionTypeId',
        operator: 0,
        value: transTypeFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 3,
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'transactionDate',
        operator: 5,
        value: dateTo
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  const clearFilters = () => {
    setBranchFilter(null);
    setInventoryFilter(null);
    setTransTypeFilter(null);
    setDateFrom('');
    setDateTo('');

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ===========================
  // DynamicFilter (السلايدر)
  // ===========================
  const fields: any = [
    { name: 'code', label: t('Code'), type: 'string' },
    { name: 'transactionDate', label: t('TransactionDate'), type: 'date' },
    { name: 'referenceCode', label: t('ReferenceNumber'), type: 'string' },

    { name: 'branchId', label: t('OperationUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'inventoryId', label: t('Inventory'), type: 'options', options: InventoryOptions },

    // ✅ نوع الحركة (من خيارات الصفحة الحالية)
    { name: 'transactionTypeId', label: t('TransType'), type: 'options', options: transTypeOptions },

    // للعرض فقط (غالباً كلها false في Unposted)
    {
      name: 'postedFlag',
      label: t('PostingStatus'),
      type: 'options',
      options: [
        { value: true, label: t('Posted') },
        { value: false, label: t('NotPosted') }
      ]
    }
  ];

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('CreateAccountInventory') || 'ترحيل العمليات المخزنية', link: null }
  ];

  return (
    <div>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('CreateAccountInventory') || 'ترحيل العمليات المخزنية'} />

        <div className='ms-auto d-flex gap-2'>
          {HasPermission('INVAddCreateAccountInventory') && (
            <button
              type='button'
              className='btn btn-theme'
              onClick={handleOpenPostModal}
              disabled={selectedTransactions.length === 0}
              title={t('Post')}
            >
              <i className='fa fa-share-square fa-fw me-1'></i>
              {t('PostSelectedVouchers') || 'ترحيل المحدد'} ({selectedTransactions.length})
            </button>
          )}
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ وحدة التشغيل */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  isLoading={loadingOperatingUnitOptions}
                  value={branchFilter}
                  onChange={setBranchFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('OperationUnit')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ المخزن */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-warehouse'></i>
                </span>
                <Select
                  isLoading={loadingInventoryOptions}
                  value={inventoryFilter}
                  onChange={setInventoryFilter}
                  options={InventoryOptions}
                  placeholder={t('Inventory')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ نوع الحركة (من بيانات الصفحة) */}
            <div className='col-lg-4'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-layer-group'></i>
                </span>
                <Select
                  value={transTypeFilter}
                  onChange={setTransTypeFilter}
                  options={transTypeOptions}
                  placeholder={t('TransType')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>

            {/* ✅ Date From-To */}
            <div className='col-lg-6'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                />
                <span className='input-group-text'>-</span>
                <input type='date' className='form-control' value={dateTo} onChange={e => setDateTo(e.target.value)} />
              </div>
            </div>

            {/* ✅ Buttons */}
            <div className='col-lg-6 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>

              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={!branchFilter && !inventoryFilter && !transTypeFilter && !dateFrom && !dateTo}
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>

              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <CardBody className='p-0'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='bg-theme bg-opacity-25 fw-bold'>
                  <tr>
                    <th className='small text-center' style={{ width: 40 }}>
                      <div className='form-check d-flex justify-content-center'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          checked={!!data?.length && data.every((row: any) => selectedTransactions.some(s => s.id === row.id))}
                          onChange={handleSelectAllPage}
                        />
                      </div>
                    </th>

                    <th className='small'>{t('Code')} / {t('TransactionDate')}</th>
                    <th className='small'>{t('TransType')} / {t('ReferenceNumber')}</th>
                    <th className='small'>{t('OperationUnit')} / {t('Inventory')}</th>
                    <th className='small text-center'>{t('PostingStatus')}</th>
                  </tr>
                </thead>

                <tbody>
                  {data.length > 0 ? (
                    data.map((item: any) => {
                      const transTypeName =
                        i18n.language === 'en'
                          ? item.transactionTypeName
                          : item.transactionTypeName2 || item.transactionTypeName;

                      const branchName =
                        i18n.language === 'en' ? item.branchName : item.branchName2 || item.branchName;

                      const invName =
                        i18n.language === 'en' ? item.inventory : item.inventory2 || item.inventory;

                      return (
                        <tr key={item.id}>
                          <td className='align-middle text-center'>
                            <div className='form-check d-flex justify-content-center'>
                              <input
                                type='checkbox'
                                className='form-check-input'
                                checked={isRowSelected(item)}
                                onChange={() => handleCheckboxChange(item)}
                              />
                            </div>
                          </td>

                          {/* رقم + تاريخ */}
                          <td className='align-middle'>
                            <div className='d-flex flex-column'>
                              <div className='fw-bold text-theme' style={{ letterSpacing: '0.05em' }}>
                                {item.code}
                              </div>
                              <small className='text-muted'>
                                <i className='fas fa-calendar-alt me-1'></i>
                                {safeDate(item.transactionDate)}
                              </small>
                            </div>
                          </td>

                          {/* نوع + مرجع */}
                          <td className='align-middle'>
                            <div className='d-flex flex-column gap-1'>
                              <div>{getTransactionBadge(transTypeName)}</div>
                              <div>
                                {item.referenceCode ? (
                                  <span className='badge bg-secondary bg-opacity-35 text-body' title={item.referenceCode}>
                                    <i className='fas fa-hashtag me-1'></i>
                                    {item.referenceCode}
                                  </span>
                                ) : (
                                  <span className='text-muted'>—</span>
                                )}
                              </div>
                            </div>
                          </td>

                          {/* وحدة التشغيل + المخزن */}
                          <td className='align-middle'>
                            <div className='d-flex flex-column'>
                              <div className='fw-bold'>
                                <i className='fas fa-building me-1'></i>
                                {branchName || '—'}
                              </div>
                              <small className='text-muted mt-1'>
                                <i className='fas fa-warehouse me-1'></i>
                                {invName || '—'}
                              </small>
                            </div>
                          </td>

                          {/* الترحيل */}
                          <td className='align-middle text-center'>{getPostedFlagBadge(item.postedFlag || false)}</td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5} className='text-center py-5 text-muted'>
                        <div className='py-4'>
                          <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                          <h5 className='mb-2'>{activeFiltersCount > 0 ? t('NoSearchResults') : t('NoData')}</h5>
                          <p className='text-muted small'>
                            {activeFiltersCount > 0 ? 'جرّب تقليل الفلاتر أو تغيير التاريخ' : 'لا توجد عمليات مخزنية بانتظار الترحيل'}
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />

      <NeatixModal show={showModal} setShow={setShowModal} bodyClassName='p-0' size='xl' showHeader={false} backdrop>
        <Card>
          <CardBody>
            {selectedTransactions.length > 0 && (
              <AddCreateAccountInventory
                selectedTransactions={selectedTransactions}
                onclose={() => {
                  setShowModal(false);
                  setSelectedTransactions([]);
                  dispatch(getPagedData({ tableKey: TABLE_KEY })); // ✅ إعادة تحميل الصفحة بعد الترحيل
                }}
              />
            )}
          </CardBody>
        </Card>
      </NeatixModal>
    </div>
  );
};

export default ListTransactionsToPost;
